/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideExpense, hideManger } from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import InputField from "../../inputs/inputField";

import InputPassword from "../../inputs/inputPassword";
import UploadPhoto from "../../inputs/UploadPhoto";
import { addDriver } from "../../../store/drivers";
import {toggleRender } from "../../../store/stateSlice";
const AddDriver = ({ isOpen, toggleModal, setOpen }) => {
  const dispatch = useDispatch();
  const errorMsgStore = useSelector((state) => state.drivers.errorMsg);
  const [errorMsg, seterrorMsg] = useState(errorMsgStore);

  const [values, setValues] = useState({
    image: null,
    name: "",
    phone: "",
    email: "",
    viewPhoto: "",
    password: ""
  });

  // State to store uploaded file
  const [file, setFile] = useState("");
  // console.log(values.file);
  function handleChange({ target }) {
    setValues({
      ...values,
      [target.name]: target.value,
      image: file,
    });

  }
  // Handles file upload event and updates state
  function handleUpload(e) {
    const file = e.target.files[0];
    setFile(file);
  }
    //function to sumbit data
    const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(addDriver({
        ...values,
        method: "POST",
        id: null,
      })
      ).then((res) => {
        if (res.payload.status === 200) {
          dispatch(toggleRender());
          setOpen(false)
          setFile("")
  
        } else {
          setOpen(true)
          dispatch(toggleRender());
          setValues({ ...values, render: true });
        }
      })
    };

  //handel errormsg validation
  useEffect(() => {
    seterrorMsg(errorMsgStore)
  }, [errorMsgStore]);
  const handelError = (key) => {
    return (
      <span className="text-error"> {errorMsg !== null && errorMsg !== undefined ? errorMsg[key] : null} </span>
    )
  }


  return (
    <Popup viewPupup={isOpen} hidePupup={toggleModal} viewWidth='content-xl'>
      <form className='main-contnt' onSubmit={handleSubmit}>
        <div className='head-content'>
          <UploadPhoto
            name='image'
            handleUpload={handleUpload}
            file={file}

          />
        </div>
        <div className='body-content'>
          <InputField
            name="name"
            value={values.name}
            title='الاسم'
            placeholder='اكتب الاسم '
            onChange={handleChange}
            note='*'
          />
          {handelError("name")}

          <InputField
            name="email"
            value={values.email}
            onChange={handleChange}
            title='البريد الالكتروني'
            placeholder='اكتب البريد الالكتروني'
            type='email'
          />
          {/* {handelError("email")} */}
          <InputField
            name="phone"
            value={values.phone}
            onChange={handleChange}
            title='رقم الموبيل '
            placeholder='اكتب رقم الموبيل'
            note='*'
            type='number'
          />
          {handelError("phone")}

          <InputPassword
            name="password"
            value={values.password}
            onChange={handleChange}
            title='الرقم السري '
            placeholder='اكتب الرقم السري *'
            note='*'
          />
          {handelError("password")}

        </div>
        <div className='buttons-contnt display-flex center-flex '>
        <input value="اضافه" type="submit" class="btn btn__primary" />
          <div class='btn btn__danger' onClick={toggleModal}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default AddDriver;
